import axios from "axios";
import { ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import avatar1 from "../../Assets/Images/TestimonialImages/testimonial1.webp";
import avatar2 from "../../Assets/Images/TestimonialImages/testimonial2.webp";
import avatar3 from "../../Assets/Images/TestimonialImages/testimonial3.webp";
import avatar4 from "../../Assets/Images/TestimonialImages/testimonial4.webp";

import icon1 from "../../Assets/Images/TestimonialImages/icon1.webp";
import icon2 from "../../Assets/Images/TestimonialImages/icon2.webp";
import icon3 from "../../Assets/Images/TestimonialImages/icon3.webp";
import icon4 from "../../Assets/Images/TestimonialImages/icon4.webp";

import user1 from "../../Assets/Images/TestimonialImages/user.webp";
import user2 from "../../Assets/Images/TestimonialImages/user2.webp";
import user3 from "../../Assets/Images/TestimonialImages/user3.webp";

import leaf from "../../Assets/Images/leaf.png";

const Testimonials = () => {

  const API = process.env.REACT_APP_API_URL;

  const [testimonialData, setTestimonialData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${API}/testimonials`);
        setTestimonialData(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch testimonials", err);
        setTestimonialData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const mappedData = testimonialData.map((item) => ({
    text: item.text,
    user: item.name,
    rating: item.rating,
    image: user1, // fallback image (since backend doesn’t have image yet)
  }));


  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(1);
  const maxIndex = Math.max(0, mappedData.length - itemsPerView);

  useEffect(() => {
    const update = () => setItemsPerView(window.innerWidth >= 768 ? 2 : 1);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1 > maxIndex ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [maxIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1 > maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 < 0 ? maxIndex : prev - 1));
  };

  return (
    <section className="bg-[#FFFAF9] py-8 md:py-12 lg:py-16 px-4 md:px-8 lg:px-12">
      <div className=" mx-auto">
        {/* Top Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-16">
          {[
            {
              img: avatar1,
              title: "Hair Colour Perfection",
              desc: "Shades that suit your style and personality.",
              bg: "bg-[#EAF9FE]",
              icon: icon1,
            },
            {
              img: avatar2,
              title: "Revive Your Hair",
              desc: "Advanced treatments for smooth & shiny hair.",
              bg: "bg-[#F3F3F4]",
              icon: icon2,
            },
            {
              img: avatar3,
              title: "Signature Mani–Pedi",
              desc: "Professional care with a flawless finish.",
              bg: "bg-[#FFEFFF]",
              icon: icon3,
            },
            {
              img: avatar4,
              title: "MakeUp",
              desc: "Advanced treatments for smooth & shiny hair.",
              bg: "bg-[#FFDEEF]",
              icon: icon4,
            },
          ].map((item, i, arr) => {
            const isEdgeCard = i === 0 || i === arr.length - 1;

            return (
              <div
                key={i}
                data-aos="zoom-in-up"
                data-aos-delay={i * 120}
                data-aos-duration="800"
                data-aos-easing="ease-out-cubic"
                className={`${item.bg} relative flex rounded-2xl h-32 sm:h-36 md:h-auto overflow-hidden border`}
              >
                {/* Left Image */}
                <img
                  src={item.img}
                  className="w-32 h-full object-cover flex-shrink-0"
                  alt=""
                />

                {/* Content */}
                <div className="relative flex flex-col justify-start  px-1 py-6 flex-1">
                  <h3 className="font-bold pt-3  font-philosopher text-[#020101] text-sm lg:text-md leading-tight">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-xs font-robotoflex text-[#616161] leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>

                {/* Decorative Icon */}
                <img
                  src={item.icon}
                  alt="decorative"
                  className={`absolute transition-all duration-300
                    ${isEdgeCard
                      ? "w-10 h-14 md:w-20 md:h-18 lg:h-20 bottom-0  xl:bottom-1 right-0"
                      : "w-12 h-12 md:w-16 md:h-16 bottom-0 xl:bottom-3 right-0"
                    }
                `}
                />
              </div>
            );
          })}
        </div>

        <div className="grid lg:grid-cols-3 gap-12 items-start relative">
          {/* Left Text */}
          <div data-aos="fade-right" className=" space-y-4 md:space-y-6 ">
            <div className="relative w-fit">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
              <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
                <img
                  src={leaf}
                  alt="leaf"
                  className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
                />
                <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                  Testimonial
                </span>
                <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
              </div>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
              <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
                Our Clients’&nbsp;
              </span>
              {/* <br /> */}
              <span className="relative">
                <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                  Glow
                </span>
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
              </span>
            </h1>

            <p className="text-[#707070] font-robotoflex text-sm md:text-base leading-relaxed tracking-wide w-full">
              At Sakhi Salon, our clients’ satisfaction speaks for itself. From
              personalized care to flawless results, their experiences reflect
              our commitment to quality, comfort, and confidence in every
              service we provide. Every visit to Sakhi Salon is more than just a
              service — it’s an experience. Our clients share stories of trust,
              transformation, and the confidence they feel after receiving
              expert care from our skilled professionals.
            </p>

            {/* Avatars */}
            <div className="flex -space-x-4">
              {[user1, user2, user3, user1].map((u, i) => (
                <img
                  key={i}
                  src={u}
                  alt="avatars"
                  className="w-10 h-10 md:w-16 md:h-16 lg:w-12 lg:h-12  rounded-full border-2 border-[#FFFAF9]"
                />
              ))}
            </div>

            {/* icon */}
            <div className="z-10 hidden lg:block absolute lg:top-80 xl:top-56 lg:left-[232px] xl:left-[458px] 2xl:left-[460px]  ">
              <img
                src={icon3}
                alt="icon"
                className="lg:w-36 lg:h-36 xl:w-40 xl:h-52 "
              />
            </div>
          </div>

          {/* Testimonial Slider */}
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            className="lg:col-span-2 relative max-w-5xl lg:ml-11 xl:ml-40 overflow-hidden"
          >
            {/* Slider Container */}
            <div className="relative overflow-hidden w-full py-4">
              {/* Slider */}
              <div
                className="flex transition-all duration-700 ease-out"
                style={{
                  transform: `translateX(-${currentIndex * (100 / itemsPerView)
                    }%)`,
                }}
              >
                {loading ? (
                  <>
                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="w-full md:w-1/2 flex-shrink-0 px-3"
                      >
                        <div className="animate-pulse relative bg-gradient-to-b from-white to-gray-50/50 rounded-2xl p-6 md:p-8 border border-white/80 shadow-lg h-full flex flex-col">

                          {/* Top bar */}
                          <div className="absolute top-0 left-0 right-0 h-1 bg-gray-200 rounded-t-2xl" />

                          {/* Quote */}
                          <div className="flex justify-center mb-6">
                            <div className="w-12 h-12 rounded-full bg-gray-200" />
                          </div>

                          {/* Text */}
                          <div className="space-y-3 mb-8 text-center">
                            <div className="h-3 bg-gray-200 rounded w-full" />
                            <div className="h-3 bg-gray-200 rounded w-5/6 mx-auto" />
                            <div className="h-3 bg-gray-200 rounded w-4/6 mx-auto" />
                          </div>

                          {/* Stars */}
                          <div className="flex justify-center gap-1 mb-8">
                            {[...Array(5)].map((_, j) => (
                              <div key={j} className="w-5 h-5 bg-gray-200 rounded" />
                            ))}
                          </div>

                          {/* User */}
                          <div className="mt-auto pt-6 border-t border-gray-100 flex items-center justify-center gap-4">
                            <div className="w-14 h-14 bg-gray-200 rounded-full" />
                            <div className="space-y-2">
                              <div className="h-3 bg-gray-200 rounded w-24" />
                              <div className="h-2 bg-gray-200 rounded w-16" />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) :
                  mappedData?.map((item, i) => (
                    <div key={i} className="w-full md:w-1/2 flex-shrink-0 px-3">
                      <div className="group relative h-full">
                        {/* Card Glow Effect */}
                        <div className="absolute -inset-0.5 bg-gradient-to-r from-[#ab310c]/20 via-[#d44a20]/20 to-[#EDB5A4]/20 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                        {/* Card */}
                        <div className="relative bg-gradient-to-b from-white to-gray-50/50 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/80 shadow-lg group-hover:shadow-2xl transition-all duration-500 group-hover:-translate-y-1 h-full flex flex-col">
                          {/* Top Pattern */}
                          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] rounded-t-2xl" />

                          {/* Quote Icon */}
                          <div className="flex justify-center mb-6 relative">
                            <div className="relative">
                              <div className="absolute -inset-4 bg-gradient-to-r from-[#ab310c]/10 to-[#EDB5A4]/10 rounded-full blur" />
                              <div className="relative w-12 h-12 bg-gradient-to-br from-[#FFFAF9] to-white rounded-full flex items-center justify-center shadow-lg">
                                <svg
                                  className="w-6 h-6 text-[#ab310c]"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                                </svg>
                              </div>
                            </div>
                          </div>

                          {/* Testimonial Text */}
                          <p className="text-gray-600 text-sm md:text-base leading-relaxed font-robotoflex mb-8 text-center flex-1 italic">
                            "{item.text}"
                          </p>

                          {/* Stars */}
                          <div className="flex justify-center mb-8">
                            <div className="flex gap-1">
                              {[...Array(5)].map((_, starIndex) => (
                                <svg
                                  key={starIndex}
                                  className={`w-5 h-5 ${starIndex < item.rating
                                    ? "fill-amber-400 text-amber-400"
                                    : "fill-gray-200 text-gray-200"
                                    }`}
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                </svg>
                              ))}
                            </div>
                          </div>

                          {/* User Info */}
                          <div className="mt-auto pt-6 border-t border-gray-100">
                            <div className="flex items-center justify-center gap-4">
                              {/* User Avatar */}
                              <div className="relative">
                                <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-30 group-hover:opacity-50 transition-opacity duration-500" />
                                <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[#ab310c] to-[#EDB5A4] flex items-center justify-center text-white font-semibold text-sm shadow-md border-2 border-white">
                                  {item.user
                                    ?.split(" ")
                                    .map((n) => n[0])
                                    .slice(0, 2)
                                    .join("")}
                                </div>
                                {/* Verified Badge */}
                                <div className="absolute -bottom-1 -right-1 bg-gradient-to-r from-emerald-500 to-emerald-600 p-1 rounded-full">
                                  <svg
                                    className="w-3 h-3 text-white"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>

                              {/* User Details */}
                              <div className="text-left">
                                <p className="font-semibold text-gray-900 text-sm md:text-base">
                                  {item.user}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              aria-label="Previous testimonial"
              disabled={currentIndex === 0}
              className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm shadow-xl hover:shadow-2xl p-3.5 rounded-full hover:scale-110 active:scale-95 transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed group"
            >
              <ChevronLeft className="w-5 h-5 text-gray-700 group-hover:text-[#ab310c] transition-colors" />
            </button>

            <button
              onClick={nextSlide}
              aria-label="Next testimonial"
              disabled={currentIndex === maxIndex}
              className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm shadow-xl hover:shadow-2xl p-3.5 rounded-full hover:scale-110 active:scale-95 transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed group"
            >
              <ChevronRight className="w-5 h-5 text-gray-700 group-hover:text-[#ab310c] transition-colors" />
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2.5 mt-10">
              {Array.from({ length: maxIndex + 1 }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                  className={`relative rounded-full transition-all duration-500 hover:scale-125 ${currentIndex === i
                    ? "bg-gradient-to-r from-[#ab310c] to-[#d44a20] w-8"
                    : "bg-gray-300 hover:bg-gray-400 w-2.5"
                    } h-2.5`}
                >
                  {currentIndex === i && (
                    <span className="absolute -top-6 left-1/2 transform -translate-x-1/2 text-xs font-medium text-gray-700 whitespace-nowrap">
                      {i + 1} / {maxIndex + 1}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
